module.exports = __webpack_public_path__ + "static/media/Roboto-ThinItalic.7384da64.ttf";